export default {
  // list
  'crm_customer_contact.column.customerId': '客户ID',
  'crm_customer_contact.column.contactName': '联系人',
  'crm_customer_contact.column.contactPhone': '联系方式',
  'crm_customer_contact.column.contactType': '联系人类型',
  'crm_customer_contact.column.primaryFlag': '是否首选',
  'crm_customer_contact.column.enableFlag': '是否启用',
  'crm_customer_contact.column.createBy': '创建人',
  'crm_customer_contact.column.updateBy': '更新人',
  'crm_customer_contact.column.createTime': '创建时间',
  'crm_customer_contact.column.updateTime': '更新时间',
  'crm_customer_contact.column.dataSource': '数据来源',
  'crm_customer_contact.column.remark': '备注',
  'crm_customer_contact.column.status': '状态',
  // edit
  'crm_customer_contact.edit.title': '编辑客户联系人',
  'crm_customer_contact.add.title': '新增客户联系人',
  'crm_customer_contact.edit.success': '编辑成功',
  'crm_customer_contact.add.success': '新增成功',
  'crm_customer_contact.form.contactName.required': '联系人不能为空',
  'crm_customer_contact.form.contactPhone.required': '联系方式不能为空',
  'crm_customer_contact.form.contactType.required': '联系人类型不能为空',
  'crm_customer_contact.form.primaryFlag.required': '是否首选不能为空',
  'crm_customer_contact.form.enableFlag.required': '是否启用不能为空',
  'crm_customer_contact.form.contactName': '联系人',
  'crm_customer_contact.form.contactName.placeholder': '请输入联系人',
  'crm_customer_contact.form.contactPhone': '联系方式',
  'crm_customer_contact.form.contactPhone.placeholder': '请输入联系方式',
  'crm_customer_contact.form.contactType': '联系人类型',
  'crm_customer_contact.form.contactType.placeholder': '请输入联系人类型',
  'crm_customer_contact.form.primaryFlag': '是否首选',
  'crm_customer_contact.form.primaryFlag.placeholder': '请输入是否首选',
  'crm_customer_contact.form.enableFlag': '是否启用',
  'crm_customer_contact.form.enableFlag.placeholder': '请输入是否启用',
}
